// extracted by mini-css-extract-plugin
module.exports = {"status":"styles_status__2Q_LI","content":"styles_content__15dKr"};